export class ProductsWidgetRelated {
    constructor (target) {
      this.section = target;
    }

    async init () {
      const { default: Swiper } = await import('swiper');

      await import('swiper/css');

      const config = {
        slidesPerView: 1.2,
        spaceBetween: 28,
        enabled: true,
        a11y: {
          slideRole: 'presentation',
          slideLabelMessage: '',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
            enabled: true,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 28,
            enabled: false,
          },
        },
      };

      const sliderElement = this.section.querySelector('.swiper')

      new Swiper(sliderElement, config);

      this.loading(false);
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
